import React from "react";
import styled from "styled-components";

type SwitchInputProps = {
    value?: boolean;
    onChange?: (value: boolean) => void;
    trueLabel?: string;
    falseLabel?: string;
}

export const SwitchInput = React.forwardRef<HTMLButtonElement, SwitchInputProps>(
    ({
        value,
        onChange,
        trueLabel = 'Yes',
        falseLabel = 'No',
    }, ref) => (
        <Switch
            ref={ref}
            role='switch'
            type="button"
            defaultChecked={value}
            onClick={() => onChange?.(!value)}
        >
            <div className="toggle"></div>
            <span>{value ? trueLabel : falseLabel}</span>
        </Switch>
    )
);

SwitchInput.displayName = 'SwitchInput';

const Switch = styled.button<{ $checked?: boolean }>`
    display: flex;
    align-items: center;
    gap: 4px;
    border: none;
    padding: 4px;
    border-radius: 20px;
    font-size: 14px;
    ${({ defaultChecked }) => defaultChecked ? 'padding-left' : 'padding-right'}: 8px;
    background: ${({ defaultChecked }) => defaultChecked ? '#02A340' : '#F2F2F2'};
    color: ${({ defaultChecked }) => defaultChecked ? 'white' : 'black'};
    flex-direction: ${({ defaultChecked }) => defaultChecked ? 'row-reverse' : 'row'};

    .toggle {
        width: 24px;
        height: 24px;
        background: white;
        border-radius: 50%;
    }
`